export type FpsEventMarker = {
  timestamp: number;
  type: string;
  label: string;
  color: string;
};

class FpsEventMarkersManager
{
  private markers: FpsEventMarker[] = [];
  private readonly MAX_MARKERS = 100;

  addMarker( type: string, label: string, color: string ): void
  {
    this.markers.push( {
      timestamp: performance.now(),
      type,
      label,
      color
    } );

    if ( this.markers.length > this.MAX_MARKERS )
    {
      this.markers.shift();
    }
  }

  getMarkers(): FpsEventMarker[]
  {
    return this.markers;
  }

  clearOldMarkers( cutoffTime: number ): void
  {
    this.markers = this.markers.filter( m => m.timestamp > cutoffTime );
  }
}

export const fpsEventMarkers = new FpsEventMarkersManager();
